import { render, staticRenderFns } from "./DetailCard.vue?vue&type=template&id=0bbcc7bc&scoped=true"
import script from "./DetailCard.vue?vue&type=script&lang=js"
export * from "./DetailCard.vue?vue&type=script&lang=js"
import style0 from "./DetailCard.vue?vue&type=style&index=0&id=0bbcc7bc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbcc7bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/bamboo-agent-home/xml-data/build-dir/MEM-MEMUI-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bbcc7bc')) {
      api.createRecord('0bbcc7bc', component.options)
    } else {
      api.reload('0bbcc7bc', component.options)
    }
    module.hot.accept("./DetailCard.vue?vue&type=template&id=0bbcc7bc&scoped=true", function () {
      api.rerender('0bbcc7bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/detail-card/DetailCard.vue"
export default component.exports